import { appstr } from "../utils/appstr";
import { enumBoxSubTypes, kIndexSCID } from "../constants";
import { formatArray } from "../utils/formatArray.js";
import { GetNameDefForObj } from "../utils/GetNameDefForObj.js";
import {
  sanitizeBlockedValue,
  isBlockedField,
  getBlockedFieldDisplayValue
} from "../utils/FormatFieldValue";
import { StringToBool } from "../utils/StringToBool.js";
import { QSerialSCObject } from "./QSerialSCObject";
import { QXMLObject } from "./QXMLObject";
import { Globals } from "./Globals";

export class QSubChart extends QXMLObject {
  constructor() {
    super();
    this.fSubChartID = null;
    this.fParentSubChart = null;
    this.fParentSubChartID = null;

    this.fTopDBObj = null;
    this.fTopDBObjID = null;
    this.fTopObjRef = null;

    this.fSubChartName = null;
    this.fSubChartFieldID = null;
    this.fOverrideField = false;
    this.fFieldDef = null;
    this.fChildren = null;

    this.fRootOrder = null;
    this.fRootOrderLoad = null;

    this.fIsMaster = false;
    this.fSCMgr = null;

    this.fNeedOptimize = false;
    this.fBranchStyleOverride = false;
    this.forceTemplate = undefined;

    this.fLoadedLevels = -1;
    this.fChainLoaded = 0;
    this.fDirty = false;
    this.fPlanChecksum = null;
  }

  //=================================================================================================
  // Initialize
  InitSubChart(id, parentSubChart, topDBObj, subChartName, fieldID, scMgr) {
    this.fSCMgr = scMgr;
    this.fSubChartID = id;
    this.DoInit();

    this.SetParent(parentSubChart);
    this.fSubChartName = subChartName;
    this.fSubChartFieldID = fieldID;

    if (topDBObj != null) this.SetTopDBObj(topDBObj);

    if (parentSubChart != null) parentSubChart.AddChildSubChart(this);
  }

  SetNeedOptimize(needOptimize) {
    this.fNeedOptimize = needOptimize;
  }

  GetNeedOptimize() {
    return this.fNeedOptimize;
  }

  SetDirty(isDirty) {
    this.fDirty = isDirty;
  }

  IsDirty() {
    return this.fDirty;
  }

  SetSubChartMgr(subChartMgr) {
    this.fSCMgr = subChartMgr;
  }

  GetSubChartMgr() {
    return this.fSCMgr;
  }

  GetTopObjField(sortKey) {
    var topObj = this.GetTopDBObj();
    var sortDef = topObj.GetFieldDefByName(sortKey);
    if (!sortDef) return "";
    var fieldVal = topObj.GetFieldValue(sortDef);
    if (fieldVal) return fieldVal;
    return "";
  }

  DoInit() {
    this.SetXMLElementName("subchart");
    this.fChildren = [];
    this.ClearRootOrder();
  }

  //=================================================================================================
  // Undo/Redo
  Journal() {
    this.fSCMgr.JournalSubChartChg(this);
  }

  SerialClone() {
    var c = new QSerialSCObject();
    c.Init(this);

    return c;
  }

  //=================================================================================================
  // Get/Set
  SetTopDBObjRef(topObjRef) {
    this.fTopObjRef = topObjRef;
  }

  GetTopDBObjRef() {
    return this.fTopObjRef;
  }

  SetSubChartFullName(fullName) {
    this.fSubChartFullName = fullName;
  }

  GetSubChartFullName() {
    return this.fSubChartFullName || "";
  }

  SetTopDBObj(topDBObj) {
    this.Journal();
    this.fTopDBObj = topDBObj;
    this.fTopDBObjID = topDBObj.GetObjectID();
  }

  AddTopDBObj(obj) {
    this.Journal();
    if (obj == null) return;
    this.fDataObjArr.push(obj);
    this.fDataObjIDArr = this.fDataObjArr.map(function (a) {
      return a.GetObjectID();
    });
  }

  SetTopDBObjArr(objArr) {
    this.Journal();
    this.fDataObjArr = objArr;
    this.fDataObjIDArr = objArr.map(function (a) {
      return a.GetObjectID();
    });
  }

  RemoveTopDBObj(dbObj) {
    if (this.fDataObjArr && this.fDataObjArr.indexOf(dbObj) > -1) {
      var oldIndex = this.fDataObjArr.indexOf(dbObj);
      this.fDataObjArr.splice(oldIndex, 1);
      this.SetTopDBObjArr(this.fDataObjArr);
      return true;
    }
    return false;
  }

  GetSubChartID() {
    return this.fSubChartID;
  }

  GetSubChartParent() {
    return this.fParentSubChart;
  }

  GetSubChartParentID() {
    return this.fParentSubChartID;
  }

  LoadFieldRef() {
    //????
    if (this.fFieldDef == null) {
      var dbObj = this.fTopDBObj;
      if (dbObj == null) return;
      if (this.fSubChartFieldID != null) {
        this.fFieldDef = dbObj.GetFieldDefByID(this.fSubChartFieldID);
        if (this.fFieldDef == null) this.fFieldDef = dbObj.GetFieldDefByName(this.fSubChartFieldID);
        if (this.fFieldDef == null) {
          this.fSubChartFieldID = this.fSubChartFieldID.replace(" ", "");
          this.fFieldDef = dbObj.GetFieldDefByName(this.fSubChartFieldID);
        }
        if (this.fFieldDef == null) this.fSubChartFieldID = null; //UNDO/REDO?
      }
    }
  }

  GetSubChartNum() {
    var s = "1";
    var p = this.GetSubChartParent();
    var branchRoot = this.fSCMgr.fBranchRoot;
    var branchParent = null;

    if (branchRoot) branchParent = branchRoot.GetSubChartParent();

    if (p != branchParent && p != null) {
      var index = p.GetChildIndex(this) + 1;
      s = p.GetSubChartNum() + "." + index;
    }

    return s;
  }

  OverrideSubChartName() {
    return this.fOverrideField;
  }

  GetSubChartName(forceShowNum) {
    var scn = "";
    var dbObj = null;

    if (this.fSubChartName != null) {
      if (!this.fOverrideField) {
        // Backend-populated names bypass CRLS. Cross-check the data object,
        // which has CRLS applied, to detect blocked fields.
        dbObj = this.fTopDBObj;
        if (!dbObj && this.fTopObjRef && this.fSCMgr) {
          dbObj = this.fSCMgr.LookupObjByRef(this.fTopObjRef);
        }
        if (dbObj) {
          if (!this.fFieldDef && this.fSubChartFieldID) {
            this.fFieldDef = dbObj.GetFieldDefByID(this.fSubChartFieldID);
            if (!this.fFieldDef) this.fFieldDef = dbObj.GetFieldDefByName(this.fSubChartFieldID);
            if (!this.fFieldDef) {
              this.fFieldDef = dbObj.GetFieldDefByName(this.fSubChartFieldID.replace(" ", ""));
            }
          }
          if (this.fFieldDef && isBlockedField(dbObj.GetFieldValue(this.fFieldDef))) {
            scn = getBlockedFieldDisplayValue();
          } else {
            scn = sanitizeBlockedValue(this.fSubChartName);
          }
        } else {
          scn = sanitizeBlockedValue(this.fSubChartName);
        }
      } else {
        scn = this.fSubChartName;
      }
    } else {
      dbObj = this.fTopDBObj;
      if (dbObj == null) {
        scn = appstr("subchartname");
        return scn;
      }

      this.LoadFieldRef();
      if (this.fFieldDef) {
        var fieldDef = this.fFieldDef;
        if (this.fDataObjArr && this.fDataObjArr.length > 0) {
          //Step 1: Grab all the values for the data objects
          var valueArray = this.fDataObjArr.map(function (a) {
            return sanitizeBlockedValue(a.GetFieldValue(fieldDef), "");
          });
          //Step 2: Remove the duplicates (if any - just in case)
          valueArray = valueArray.filter(function (value, index, array) {
            return array.indexOf(value) === index && value !== "";
          });
          scn = formatArray(valueArray);
        } else scn = sanitizeBlockedValue(dbObj.GetFieldValue(fieldDef), "");
      }
    }
    if ((scn == null || scn.length === 0) && dbObj) {
      var objID = dbObj.GetObjectRecordID();
      if (objID != null && objID != "") {
        // fall back to PersonID/PositionID if it is available
        scn = objID;
      } else {
        // if recordID DNE, try falling back to title value
        var titleDef = dbObj.GetTitleFieldDef();
        var theTitle = sanitizeBlockedValue(dbObj.GetFieldValue(titleDef), "");
        scn = theTitle;
        var nDef = GetNameDefForObj(dbObj);
        if ((objID == null || objID == "") && (scn == "" || scn == null)) {
          // if title DNE, try for Name
          objID = sanitizeBlockedValue(dbObj.GetFieldValue(nDef), "");

          // if Name DNE, use unique Object ID
          if (objID == null || objID == "") objID = dbObj.GetObjectID();
          // <Blank - > format if and only if title Value + PersonID/PositionID DNE
          scn = "<" + appstr("Blank") + "-" + objID + ">";
        }
      }
    }

    var scm = this.GetSubChartMgr();
    if (scm.ShowSubChartNum() || forceShowNum) scn = scn + " (" + this.GetSubChartNum() + ")";

    return String(scn);
  }

  SetSubChartName(subChartName) {
    this.Journal();
    this.fSubChartName = subChartName;
    this.fOverrideField = subChartName.length > 0;
  }

  SetSubChartFieldID(fieldID) {
    this.Journal();
    this.fSubChartFieldID = fieldID;
    this.fFieldDef = null;
    this.fSubChartName = null;
    this.fOverrideField = false;
  }

  GetSubChartFieldID() {
    return this.fSubChartFieldID;
  }

  GetTopDBObj() {
    return this.fTopDBObj;
  }

  IsTopObjRelated(dbObj) {
    const topObj = this.GetTopDBObj();
    if (dbObj == topObj) {
      return true;
    }

    if (!topObj || !topObj.IsPositionObj()) {
      return false;
    }

    const holderList = topObj.GetHolderList();
    return holderList.includes(dbObj);
  }

  GetTopDBObjID() {
    return this.fTopDBObjID;
  }

  IsInMainSubChart(dbObj) {
    if (dbObj == null) return false;

    var topID = this.GetTopDBObjID();
    var dbObjArr = this.fDataObjArr;
    if (dbObjArr && dbObjArr.indexOf(dbObj) > -1) return true;
    var dbObjID = dbObj.GetObjectID();
    if (dbObjID == topID) return true;
    else {
      var p = dbObj.GetParent();
      if (p != null) return this.IsInMainSubChart(p);
    }

    return false;
  }

  // Add sorted into the children by position in the chart
  AddChildSubChart(subChart) {
    this.Journal();
    var commonParent = this.GetTopDBObj();
    var topOfSC1 = subChart.GetTopDBObj();

    var n = this.ChildCount();
    if (n == 0 || commonParent == topOfSC1) {
      this.fChildren.push(subChart);
      return;
    }

    var parent1 = topOfSC1.GetParent();
    if (parent1 == null && commonParent != null) return "failure";

    //CB 2019-11-17 Suppressing this behavior because of comgr/cohead. Not sure what exactly this is preventing. May cause issues, particularly during import.
    /*
	while (commonParent != parent1)
	{
        topOfSC1 = parent1;
        parent1 = parent1.GetParent();
        if (parent1 == null)
        {
            // This shouldn't happen...
            //return "failure";
        }
	}
     */

    this.fChildren.push(subChart);
    return "success";
  }

  //=================================================================================================
  // Manage Children
  AppendChildSubChart(subChart) {
    this.fChildren.push(subChart);
  }

  RemoveChild(subChart) {
    this.Journal();
    var i = this.fChildren.indexOf(subChart);
    if (i != -1) this.fChildren.splice(i, 1);
  }

  ChildCount() {
    return this.fChildren.length;
  }

  GetIndexChild(index) {
    return this.fChildren[index];
  }

  GetChildIndex(child) {
    return this.fChildren.indexOf(child);
  }

  SwapChildren(index1, index2) {
    this.Journal();
    var t1 = this.fChildren[index1];
    var t2 = this.fChildren[index2];
    this.fChildren[index1] = t2;
    this.fChildren[index2] = t1;

    var scm = this.GetSubChartMgr();
    scm.SyncSubChartList();
  }

  SetParent(parentSubChart) {
    this.Journal();
    this.fParentSubChart = parentSubChart;
    var pID = null;
    if (parentSubChart != null) pID = parentSubChart.GetSubChartID();
    this.fParentSubChartID = pID;
  }

  GetChildren() {
    return this.fChildren;
  }

  //=================================================================================================
  // Load & Save
  SaveRootOrder() {
    if (this.fRootOrderLoad == null && this.fRootOrder) {
      this.fRootOrderLoad = [];
      for (var i in this.fRootOrder) {
        var objID = this.fRootOrder[i].fDataObjID;
        this.fRootOrderLoad.push(objID);
      }
    }
  }

  LoadFromJSON(json) {
    this.fSubChartID = json["ID"];

    this.fParentSubChartID = json["parentID"];

    this.fSubChartName = json["subchartName"];
    this.fOverrideField = this.fSubChartName && this.fSubChartName.length > 0;

    this.fTopDBObjID = json["topObjID"];

    this.fNeedOptimize = json["needsOptimize"];

    this.fDataObjIDArr = json["dataObjArr"];

    this.fSubChartFieldID = json["fieldRef"];

    this.fBranchStyleOverride = json["branchStyleOverride"];

    if (json["zOrder"]) {
      this.fRootOrderLoad = json["zOrder"];
    }
  }

  OutputToJSON(stream) {
    var subchart = {};
    subchart["ID"] = this.fSubChartID;

    var parentID = this.fParentSubChartID;
    var topObj = this.GetTopDBObj();

    if (topObj && topObj["ignoreSCTop"] == true) parentID = -1;

    subchart["parentID"] = parentID;

    if (this.fSubChartName) subchart["subchartName"] = this.fSubChartName;

    if (this.fTopDBObjID != null) subchart["topObjID"] = this.fTopDBObjID;

    subchart["needsOptimize"] = this.fNeedOptimize;

    if (this.fDataObjArr && this.fDataObjArr.length > 0)
      //comanagers
      subchart["dataObjArr"] = this.fDataObjArr.map(function (a) {
        return a.GetObjectID();
      });

    var fieldID = "";
    this.LoadFieldRef();
    if (this.fFieldDef) fieldID = this.fFieldDef.GetFieldID();

    subchart["fieldRef"] = fieldID;

    this.SaveRootOrder();
    if (this.fRootOrderLoad && this.fRootOrderLoad.length > 0)
      subchart["zOrder"] = this.fRootOrderLoad;

    this.ClearRootOrderLoad();

    subchart["branchStyleOverride"] = this.fBranchStyleOverride;

    return subchart;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("subchartid", this.fSubChartID, stream);

    var parentID = this.fParentSubChartID;
    var topObj = this.GetTopDBObj();

    if (topObj && topObj["ignoreSCTop"] == true) parentID = -1;

    this.OutputSimpleElement("parentid", parentID, stream);

    if (this.fSubChartName) this.OutputSimpleElement("subchartname", this.fSubChartName, stream);

    if (this.fTopDBObjID != null) this.OutputSimpleElement("topobjid", this.fTopDBObjID, stream);

    if (this.fNeedOptimize) this.OutputSimpleElement("needopt", this.fNeedOptimize, stream);

    if (this.fDataObjArr && this.fDataObjArr.length > 0)
      this.OutputElementList(
        "dataobjarr",
        this.fDataObjArr.map(function (a) {
          return a.GetObjectID();
        }),
        stream
      );

    var fieldID = "";
    this.LoadFieldRef();
    if (this.fFieldDef) fieldID = this.fFieldDef.GetFieldID();

    this.OutputSimpleElement("fieldref", fieldID, stream);

    //if (this.fRootOrderLoad == null && this.fRootOrder)
    this.SaveRootOrder();
    if (this.fRootOrderLoad && this.fRootOrderLoad.length > 0)
      this.OutputElementList("zorder", this.fRootOrderLoad, stream);
    this.ClearRootOrderLoad();
  }

  LoadChildElements(objTree) {
    this.fSubChartID = objTree.GetValueForChild("subchartid", true);
    this.fParentSubChartID = objTree.GetValueForChild("parentid", true);

    var scname = objTree.GetValueForChild("subchartname", false);
    this.fSubChartName = scname;

    this.fTopDBObjID = objTree.GetValueForChild("topobjid", true);

    var coMgrArr = objTree.GetValueListForChild("dataobjarr", false);
    if (coMgrArr) this.fDataObjIDArr = coMgrArr;

    this.fNeedOptimize = false;
    var needOpt = objTree.GetValueForChild("needopt", false);
    if (needOpt) this.fNeedOptimize = StringToBool(needOpt);

    this.fSubChartFieldID = objTree.GetValueForChild("fieldref", false);
    this.fOverrideField = this.fSubChartName && this.fSubChartName.length > 0;

    //	console.log("Zorder Load");
    var valueList = objTree.GetValueListForChild("zorder", false);
    this.fRootOrderLoad = [];
    var n = 0;
    if (valueList) n = valueList.length;
    for (var i = 0; i < n; i++) {
      var v = valueList[i];
      if (v.length > 0) {
        v = parseInt(valueList[i]);
        if (this.fRootOrderLoad.indexOf(v) == -1) this.fRootOrderLoad.push(v);
        //		console.log(v);
      }
    }
  }

  GetRootOrderLoad() {
    return this.fRootOrderLoad;
  }

  ClearRootOrderLoad() {
    this.fRootOrderLoad = null;
  }

  ClearRootOrder() {
    this.fRootOrder = [];
  }

  //=================================================================================================
  // Field Management
  RemoveFieldReferences(fieldRefList, updateRef = false) {
    var curField = this.fFieldDef;
    if (curField == null) return false;

    var scm = this.GetSubChartMgr();
    var curDoc = scm.GetDoc();
    var objDB = curDoc.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");

    var n = fieldRefList.length;
    for (var i = 0; i < n; i++) {
      var newFieldDef = null;
      var newSCFID = null;
      var aFieldRef = fieldRefList[i];
      var matchingUpdateID = updateRef && curField.GetFieldID() == aFieldRef.GetFieldID();
      if (curField == aFieldRef || matchingUpdateID) {
        if (matchingUpdateID) {
          var fieldRefID = curField.GetFieldID();
          var activeFieldDefRef = boxClass.GetFieldDefByID(fieldRefID);
          if (activeFieldDefRef != null) {
            newFieldDef = activeFieldDefRef;
          }
        }

        this.fFieldDef = newFieldDef;
        this.fSubChartFieldID = newSCFID;

        return true;
      }
    }
    if (updateRef) {
      this.fFieldDef = null;
      this.fSubChartFieldID = null;
    }
    return false;
  }

  //=================================================================================================
  // ZOrder Management
  AddToZOrder(aNode) {
    if (aNode == null) console.log("AddToZOrder node is null!");
    else {
      this.fRootOrder.push(aNode);
    }
  }

  RemoveFromZOrder(aNode) {
    var index = this.fRootOrder.indexOf(aNode);
    if (index != -1) this.fRootOrder.splice(index, 1);
  }

  ShiftRenderOrder(nodes, mode) {
    var rootOrder = this.fRootOrder;

    nodes = nodes.filter(function (aNode) {
      var anIdx = rootOrder.indexOf(aNode);
      if (anIdx === -1) return false;
      else if (anIdx === 0 && mode === "sendbackward") return false;
      else if (anIdx === rootOrder.length - 1 && mode === "bringforward") return false;
      else return true;
    });
    if (nodes.length < 1) return;

    var indexes = nodes.map(function (aNode) {
      return rootOrder.indexOf(aNode);
    });
    var rootOrderClone = rootOrder.filter(function (aNode) {
      return nodes.indexOf(aNode) < 0;
    });

    var a = -1;
    switch (mode) {
      case "bringtofront":
        rootOrderClone.push(...nodes);
        break;
      case "sendtoback":
        rootOrderClone.unshift(...nodes);
        break;
      case "bringforward":
        a += 2;
      case "sendbackward": // intentional fallthrough
        indexes = indexes.map(function (anIdx) {
          return anIdx + a;
        });
        for (var i = 0; i < indexes.length; i++) {
          var anIdx = indexes[i];
          var aNode = nodes[i];
          rootOrderClone.splice(anIdx, 0, aNode);
        }
    }

    var canvasPanel = Globals._wsMgr.fCanvasPanel;
    var plm = canvasPanel.GetPageLayoutMgr();

    for (var i = 0; i < rootOrderClone.length; i++) {
      var aRoot = rootOrderClone[i];
      var aLayout = aRoot.GetLayout();
      if (aLayout.GetBoxSubType() === enumBoxSubTypes.chartBox) continue;
      var layoutClone = aRoot.GetLayout().Clone();
      layoutClone.fSubChartID = null;
      var removeResult = plm.RemoveNode(aRoot, true);
      if (removeResult === true) canvasPanel.PRemoveChartBox(aRoot.fChartBox);
      canvasPanel.AddChartBox(
        layoutClone.GetPositionX(),
        layoutClone.GetPositionY(),
        layoutClone,
        null,
        null,
        false,
        true,
        false,
        true,
        null,
        false
      );
    }
  }

  OrderRoots(roots) {
    var clone = this.fRootOrder.slice(0);
    var m = clone.length;
    for (var i = 0; i < m; i++) clone[i]["found"] = false;

    var n = roots.length;
    for (var i = 0; i < n; i++) {
      var index = clone.indexOf(roots[i]);
      clone[index]["found"] = true;
    }

    for (var i = m - 1; i >= 0; i--) {
      if (clone[i]["found"] == false) clone.splice(i, 1);
    }

    return clone;
  }

  GetRootOrderList() {
    return this.fRootOrder;
  }

  LogSubChart(nodeList) {
    var childrenSubChartIDs = [];
    for (var i = 0; i < this.fChildren.length; i++) {
      childrenSubChartIDs.push(this.fChildren[i].fSubChartID);
    }

    var nodeListIDs = [];
    for (i = 0; i < nodeList.length; i++) {
      nodeListIDs.push(nodeList[i].fDataObjID);
    }

    console.log(
      "  " +
        this.fSubChartID +
        " Parent:" +
        this.fParentSubChartID +
        " Children: [" +
        childrenSubChartIDs +
        "] TopNode:" +
        this.fTopDBObjID +
        " Contents: " +
        nodeListIDs
    );
  }

  GetPageNumber() {
    var pagenumber = 0;
    var parent = this.GetSubChartParent();

    const scm = this.GetSubChartMgr();
    const root = scm.GetRootSubChart();
    const isRootSc = this === root;

    if (parent && !isRootSc) {
      pagenumber += parent.GetPageNumber();
      var children = parent.GetChildren();
      var myindex = children.indexOf(this);
      for (var aChildIdx = 0; aChildIdx < myindex; aChildIdx++) {
        var theChild = children[aChildIdx];
        pagenumber += theChild.GetTotalPages();
      }
      pagenumber += myindex;
    }
    if (!parent || parent.GetSubChartID() != kIndexSCID || isRootSc) pagenumber += 1;
    return pagenumber;
  }

  GetRootSubChart() {
    var parent = this.GetSubChartParent();

    if (parent) return parent.GetRootSubChart();
    return this;
  }

  GetTotalPages() {
    var pages = 0;
    var children = this.GetChildren();
    for (var aChild in children) {
      pages += children[aChild].GetTotalPages();
    }
    pages += children.length;
    return pages;
  }

  DonateChildren(newSubchart) {
    var children = this.GetChildren();
    for (var aChild in children) {
      var theChild = children[aChild];
      newSubchart.AppendChildSubChart(theChild);
      theChild.SetParent(newSubchart);
    }
  }
}
